import * as Sentry from '@sentry/react';
import { SET_TEMPLATE_VALUES } from '../actions';

export const initialState = {
  templateValues: {},
};

const templates = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case SET_TEMPLATE_VALUES: {
      const { context, templateName, tasks } = action.payload.templateValues;
      return {
        templateValues: {
          templateContext: context,
          name: templateName,
          surveys: [
            {
              surveyType: 'session',
              questions: tasks,
            },
          ],
        },
      };
    }

    default:
      return state;
  }
};

export default templates;
